/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 21st 2022, 1:41:21 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSFormInputProps, useControlledInput } from "ui-widgets/forms";
import { ListButtonAutoComplete, ListButtonAutoCompleteProps } from "ui-widgets/select/ListButtonAutoComplete";

import { FormControl } from "@mui/material";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

interface ListButtonAutoCompleteFormInputProps<TFormData, TOption, Multiple extends boolean>
  extends OSFormInputProps<TFormData>,
    Omit<
      ListButtonAutoCompleteProps<TOption, Multiple>,
      "renderOptionWithDispatch" | "open" | "onOpen" | "onClose" | "onChangeCallBack"
    > {}

export const ListButtonAutoCompleteFormInput = <TFormData, TOption = any, Multiple extends boolean = false>(
  props: ListButtonAutoCompleteFormInputProps<TFormData, TOption, Multiple>
) => {
  const {
    controlledProps,
    field: { onChange, value },
  } = useControlledInput<TFormData>(props);

  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl>
            <ListButtonAutoComplete<TOption>
              {...props}
              {...controlledProps}
              textFieldProps={{ ...props.textFieldProps, label: props.label }}
              options={props.options}
              disableClearable
              onChangeCallBack={onChange}
              value={value as TOption}
            />
          </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
